import { useState } from 'react'

import { CookieConsentForm } from '@mondough/consent-management/ui'
import { Text, Title } from '@mondough/monzo-ui'

import { PlainLayout } from '../../components'
import { useFormatMessage } from '../../hooks'
import styles from './index.module.scss'

export default function CookiesPage() {
  const [prefsUpdated, setPrefsUpdated] = useState(false)
  const formatMessage = useFormatMessage()

  return (
    <PlainLayout
      pageTitle={formatMessage('cookies.page.title')}
      className={styles.container}
    >
      {formatMessage('cookies.card.intro')
        .split('\n')
        .map((p, i) => (
          <Text key={i} marginBottom="small">
            {p}
          </Text>
        ))}

      <Title is="h2">{formatMessage('cookies.card.settings.title')}</Title>
      <CookieConsentForm
        className={styles.form}
        onSubmit={() => setPrefsUpdated(true)}
      />
      {prefsUpdated && (
        <Text bold color="mid-teal">
          {formatMessage('cookies.card.settings.form.success')}
        </Text>
      )}

      <Title is="h2" marginBottom="small">
        {formatMessage('cookies.card.other.title')}
      </Title>
      {formatMessage('cookies.card.other.description')
        .split('\n')
        .map((p, i) => (
          <Text key={i} marginBottom="small">
            {p}
          </Text>
        ))}

      <Title is="h2">{formatMessage('cookies.card.questions.title')}</Title>
      <Text marginTop="extra-small">
        {formatMessage('cookies.card.questions.description')}
        <a className={styles.link} href="mailto:help@monzo.com">
          help@monzo.com
        </a>
        .
      </Text>
    </PlainLayout>
  )
}

CookiesPage.analytics = { name: 'cookie-notice' }
